import React, { useEffect, useState, useContext, forwardRef } from "react";
import { PencilAltIcon, ViewGridIcon } from "@heroicons/react/solid";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { openDB } from "idb";
import { v4 as uuid } from "uuid";
import Context from "../context/context";
import NewCategory from "./NewCategory";
import AddNewItem from "./AddNewItem";
import MenuItem from "./MenuItem";
import ItemEditPopup from "../components/itemEditPopup";

import { CSS } from '@dnd-kit/utilities';
import {
  closestCenter,
  DndContext,
  DragOverlay,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
} from '@dnd-kit/core';
import {
  arrayMove,
  useSortable,
  SortableContext,
  sortableKeyboardCoordinates,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable';

export default function Homepage() {

  const { bId, menuId } = useParams();
  const navigate = useNavigate();
  let location = useLocation()

  const [allCategories, setAllCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [itemFilter, setItemFilter] = useState("");
  const [isNewCategoryOpen, setIsNewCategoryOpen] = useState(false);
  const [isItemEditPopup, setIsItemEditPopup] = useState(false);
  const [editCategoryOpen, setEditCategoryOpen] = useState(false);
  const [categoryList, setCategoryList] = useState([]);
  const [reload, setReload] = useState(null);
  const [currentMenu, setCurrentMenu] = useState();
  const [categoryId, setCategoryId] = useState();
  const [itemId, setItemId] = useState();
  const [noCategoryPopup, setNoCategoryPopup] = useState(false);
  const [menus, setMenus] = useState([]);
  const [isNewItemPopupOpen, setIsNewItemPopupOpen] = useState(false);
  const [id, setId] = useState("");

  const context = useContext(Context);
  const { generateMenues, updateUnSync } = context;

  // Fetching all available categories with bId brand_uuid
  useEffect(() => {
    let menitem = [];
    const getDataFromIndexdDb = async () => {
      const db = await openDB("FoodDo", +localStorage?.getItem("IDBVersion") || 1);
      const indSections = await db?.transaction("menu", "readonly")?.objectStore("menu");
      const menuItems = await indSections?.getAll();
      const data = menuItems?.filter((menu) => menu?.menu_uuid === menuId);
      setCurrentMenu(data[0]);

      const allCategory = await db?.transaction("category", "readonly")?.objectStore("category");
      const currentSections = await allCategory?.getAll();
      setCategoryList(currentSections);

      let dataArr = data[0]?.category_and_items;

      function compare(a, b) {
        if (+a?.menu_category_sort_order < +b?.menu_category_sort_order) {
          return -1;
        }
        if (+a?.menu_category_sort_order > +b?.menu_category_sort_order) {
          return 1;
        }
        return 0;
      }

      dataArr = dataArr?.sort(compare);

      const dummyArr = [];

      dataArr?.forEach((menu) => {
        currentSections?.forEach((category) => {
          if (category?.category_uuid === menu?.category_uuid) {
            dummyArr?.push(category);
          }
        });
      });

      setAllCategories(dummyArr);

      dummyArr?.map((category) => {
        return menuItems
          ?.filter((men) => men?.brand_uuid === bId && men?.menu_uuid === menuId)
          ?.map((menu) => {
            return menu?.category_and_items?.map((canditem) => {
              if (canditem?.category_uuid === category?.category_uuid) {
                menitem?.push(canditem?.menu_items);
              }
              return null;
            });
          });
      });
      setMenus(menitem);
    };

    getDataFromIndexdDb();
  }, [bId, menuId, reload]);

  useEffect(() => {
    let arr = [];
    let dummyArr = [];

    function compare(a, b) {
      if (a?.menu_category_sort_order < b?.menu_category_sort_order) {
        return -1;
      }
      if (a?.menu_category_sort_order > b?.menu_category_sort_order) {
        return 1;
      }
      return 0;
    }
    if (currentMenu) {
      dummyArr = currentMenu?.category_and_items?.sort(compare);
    }

    dummyArr?.forEach((menu) => {
      categoryList?.forEach((category) => {
        if (category?.category_uuid === menu?.category_uuid) {
          arr?.push(category);
        }
      });
    });

    setAllCategories(arr);
  }, [categoryList, currentMenu, reload]);

  const handleMenuEdit = async () => {
    const db = await openDB("FoodDo", +localStorage?.getItem("IDBVersion") || 1);
    const tx = db?.transaction("menu", "readwrite")?.objectStore("menu");
    const idb_menu = await tx?.get(currentMenu?.menu_uuid);

    const unmatchedCategories = idb_menu?.category_and_items
      ?.filter(m => !currentMenu?.category_and_items?.find(u => u?.category_uuid === m?.category_uuid))

    console?.log(unmatchedCategories);
    const editedMenu = { ...(currentMenu || {}) };
    editedMenu.category_and_items = editedMenu?.category_and_items?.concat(unmatchedCategories);

    let RECON_TIME = new Date()?.getTime()?.toString();
    if (editedMenu?.hasOwnProperty("menu_title")) {
      const data = {
        ...editedMenu,
        menu_title: editedMenu?.menu_title,
        menu_type: editedMenu?.menu_type,
      };
      await tx?.put(data);
      handleMenuAddUnsyncedFiles({ ...data, RECON_TIME });
    } else {
      let data = {
        ...editedMenu,
        menu_type: editedMenu?.menu_type,
      };
      data["menu_title"] = editedMenu?.menu_title;
      await tx?.put(data);
      handleMenuAddUnsyncedFiles({ ...data, RECON_TIME });
    }
    if (location.pathname.includes("mealMenu")) {

      navigate(`/page1/`);
    } else
      navigate(`/page5/`);
  };

  // Adding/Editing new category added to menu in unsynced_files collection in IndexedDB
  const handleMenuAddUnsyncedFiles = async (data) => {
    const db = await openDB("FoodDo", +localStorage?.getItem("IDBVersion") || 1);
    const tx = await db?.transaction("unsynced_files", "readwrite")?.objectStore("unsynced_files");
    const ndata = {
      ...data,
      RECON_TIME: data?.RECON_TIME,
      IDENTIFIER: "menu-edit:" + data?.menu_uuid,
    };
    await tx?.put(ndata);
    handleMenuReconciliation(ndata);
    updateUnSync()
  };

  // Adding/Editing menu to reconciliation collection in IndexedDB
  const handleMenuReconciliation = async (data) => {
    const db = await openDB("FoodDo", +localStorage?.getItem("IDBVersion") || 1);
    const tx = await db?.transaction("reconciliation", "readwrite")?.objectStore("reconciliation");
    const allReconRecords = await tx?.getAll();

    const menusJsonExists = allReconRecords?.find((curr) => curr?.IDENTIFIER === "menu");
    if (menusJsonExists) {
      const menus = menusJsonExists?.details?.filter((menu) => menu?.menu_uuid !== data?.menu_uuid)
      const editData = {
        ...menusJsonExists,
        details: [
          ...menus,
          {
            menu_uuid: data?.menu_uuid,
            RECON_TIME: data?.RECON_TIME,
          },
        ],
      };
      await tx?.put(editData)
    } else {
      const newdata = {
        IDENTIFIER: "menu",
        details: [
          {
            menu_uuid: data?.menu_uuid,
            RECON_TIME: data?.RECON_TIME,
          },
        ]
      };
      await tx?.add(newdata);
    }

    generateMenues();
  }

  return (
    <div className="home">
      <div className="homeHeader">
        <div className="categoryheading">
          <button onClick={allCategories?.length ? () => setIsNewItemPopupOpen(!isNewItemPopupOpen)
            : () => {
              setNoCategoryPopup(true);
              setTimeout(() => setNoCategoryPopup(false), 3000)
            }}>
            + Item  
          </button>
          <button onClick={() => setIsNewCategoryOpen(!isNewCategoryOpen)}>
            + Category
          </button>
        </div>
        {currentMenu && (
          <div className="allitemheading">
            {location.pathname.includes("mealMenu") ? ""
              : <div className="menuheading">
                <label htmlFor="input">Menu Title</label>
                <input
                  placeholder="Menu Title"
                  id="input"
                  type="text"
                  maxLength="10"
                  value={currentMenu?.menu_title}
                  onChange={(e) =>
                    setCurrentMenu({
                      ...currentMenu,
                      menu_title: e?.target?.value,
                    })
                  }
                  required
                />
              </div>}
            <div className="menuheading">
              <label htmlFor="input">Item Filter</label>
              <input
                placeholder="Filter"
                id="input"
                type="text"
                maxLength="10"
                value={itemFilter}
                onChange={(e) =>
                  setItemFilter(
                    e?.target?.value
                  )
                }

              />
            </div>
            <div className="searchheadingtype">
              <button onClick={handleMenuEdit}>Submit</button>
            </div>
          </div>
        )}
      </div>

      <div className="homecontainer">
        <CategoriesSidebar
          setSelectedCategory={setSelectedCategory}
          selectedCategory={selectedCategory}
          editCategoryOpen={editCategoryOpen}
          setEditCategoryOpen={setEditCategoryOpen}
          currentMenu={currentMenu}
          setCurrentMenu={setCurrentMenu}
          menus={menus}
          allCategories={allCategories}
          setId={setId}
          setReload={setReload}
          reload={reload}
          handleMenuAddUnsyncedFiles={handleMenuAddUnsyncedFiles}
        />
        <div className="flex">
          <div className="catitemmenulist">
            {allCategories
              ?.filter(a => selectedCategory !== ""
                ? selectedCategory === a?.category_name?.replace(" ", "-")
                : a)
              ?.map((category, i) => (
                <MenuItem
                  key={i}
                  itemFilter={itemFilter}
                  category={category}
                  setCategoryId={setCategoryId}
                  setItemIds={setItemId}
                  AllCategories={allCategories}
                  ItemEditPopup={setIsItemEditPopup}
                  menus={menus}
                  setReload={setReload}
                  reload={reload}
                  currentMenu={currentMenu}
                  setCurrentMenu={setCurrentMenu}
                />
              ))}
          </div>
        </div>
        <div
          className={`copies_notification ${noCategoryPopup ? "copies_notification_active" : ""}`}
          style={{ backgroundColor: "red", zIndex: "999999" }}
        >
          Create At Least One Category !!
        </div>
        {isNewItemPopupOpen && (
          <AddNewItem
            type={"New"}
            AllCategories={allCategories}
            setCurrentMenu={setCurrentMenu}
            Menu={currentMenu}
            close={() => {
              setIsNewItemPopupOpen(!isNewItemPopupOpen);
              setReload(uuid());
            }}
          />
        )}
        {isItemEditPopup && (
          <ItemEditPopup
            setCurrentMenu={setCurrentMenu}
            categoryId={categoryId}
            itemId={itemId}
            Menu={currentMenu}
            close={() => setIsItemEditPopup(false)}
          />
        )}
        {isNewCategoryOpen && (
          <NewCategory
            type={"New"}
            AllCategories={allCategories}
            setAllCategories={setAllCategories}

            close={() => setIsNewCategoryOpen(!isNewCategoryOpen)}
          />
        )}
        {editCategoryOpen && (
          <NewCategory
            id={id}
            AllCategories={allCategories}
            setAllCategories={setAllCategories}
            close={() => setEditCategoryOpen(!editCategoryOpen)}
          />
        )}
      </div>
    </div>
  );
}

const CategoriesSidebar = ({
  setSelectedCategory,
  selectedCategory,

  editCategoryOpen,
  setEditCategoryOpen,

  currentMenu,
  setCurrentMenu,

  reload,
  setReload,

  menus,
  allCategories,
  setId,
  handleMenuAddUnsyncedFiles
}) => {

  const [categoryIds, setCategoryIds] = useState(null);
  const [activeId, setActiveId] = useState(null);
  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    })
  );

  const [hoverState, setHoverState] = useState();
  const [allItem, setAllItem] = useState([]);
  const [newMenArr, setNewMenArr] = useState([]);

  useEffect(() => {
    if (!allCategories) return;
    setCategoryIds(allCategories.map(i => i.category_uuid));
  }, [allCategories]);

  useEffect(() => {
    let x = [];
    menus?.map((u) => {
      return u?.map((n) => {
        return x?.push(n);
      });
    });
    setNewMenArr(x);
  }, [menus]);

  useEffect(() => {
    const asFnc = async () => {
      const db = await openDB("FoodDo", +localStorage?.getItem("IDBVersion") || 1);
      const indItems = await db?.transaction("item", "readonly")?.objectStore("item");
      const items = await indItems?.getAll();
      let x = [];
      newMenArr?.map((men) => {
        return items?.map((it) => {
          if (it?.item_uuid === men?.item_uuid) {
            x?.push({ ...it, ...men });
          }
          return null;
        });
      });
      setAllItem(x);
    };
    asFnc();
  }, [newMenArr, reload]);

  const handleUpdate = async (list) => {

    const menu = await currentMenu;
    menu.category_and_items = await menu.category_and_items.map(c => {
      return {
        ...c, menu_category_sort_order: list.indexOf(c.category_uuid)
      };
    });
    const db = await openDB("FoodDo", +localStorage?.getItem("IDBVersion") || 1);
    const tx = db?.transaction("menu", "readwrite")?.objectStore("menu");
    await tx?.put(menu);
    handleMenuAddUnsyncedFiles(menu);
  };

  return <div className="alcategories">
    <div style={{ position: "relative", width: "100%" }}>
      <div
        onClick={() => setSelectedCategory("")}
        className={`categorydrag ${selectedCategory === "" ? "categoryacrive" : ''}`}
      >
        <span className="catbtnspan">
          <span>
            <span>All</span>
          </span>
        </span>
      </div>
    </div>

    {categoryIds && <DndContext
      sensors={sensors}
      collisionDetection={closestCenter}
      onDragStart={handleDragStart}
      onDragEnd={handleDragEnd}
    >
      <SortableContext
        items={categoryIds}
        strategy={verticalListSortingStrategy}
      >
        {categoryIds?.map((id, i) => {
          const category = allCategories.find(j => j.category_uuid === id);
          if (category)
            return <SortableItem
              id={id}
              activeId={activeId}
              setSelectedCategory={setSelectedCategory}
              selectedCategory={selectedCategory}

              editCategoryOpen={editCategoryOpen}
              setEditCategoryOpen={setEditCategoryOpen}

              hoverState={hoverState}
              setHoverState={setHoverState}

              currentMenu={currentMenu}
              setCurrentMenu={setCurrentMenu}

              cardClass={activeId === id ? "active" : ""}
              category={category}
              setId={setId}
              allItem={allItem}
            />
          else
            return ""
        })
        }
      </SortableContext>
      <DragOverlay>
        {activeId ? <Item
          id={activeId}
          cardClass={"drag-overlay"}
          selectedCategory={selectedCategory}
          editCategoryOpen={editCategoryOpen}
          currentMenu={currentMenu}
          category={allCategories?.find(i => i.category_uuid === activeId)}
          allItem={allItem}
        /> : null}
      </DragOverlay>
    </DndContext>
    }
  </div >

  function handleDragStart(event) {
    const { active } = event;
    setActiveId(active?.id);
    console.log("drag started for id : ", active?.id)
  }

  function handleDragEnd(event) {
    const { active, over } = event;

    if (active?.id !== over?.id) {

      const oldIndex = categoryIds?.indexOf(active.id);
      const newIndex = categoryIds?.indexOf(over.id);

      let updatedIds = arrayMove(categoryIds, oldIndex, newIndex);
      setCategoryIds(updatedIds);
      handleUpdate(updatedIds);
    }
    setActiveId(null);
  }
}

const SortableItem = (props) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
  } = useSortable({ id: props?.id });

  const style = {
    transform: CSS?.Transform?.toString(transform),
    transition
  };

  return <Item
    {...props}
    ref={setNodeRef}
    style={style}
    {...attributes}
    {...listeners}
  />
}

const Item = forwardRef(({ id, activeId, setSelectedCategory, selectedCategory, editCategoryOpen, setEditCategoryOpen, hoverState, setHoverState, currentMenu, setCurrentMenu, category, setId, allItem, cardClass, style, ...props }, ref) => {
  return (<div
    key={category?.category_name?.replace(" ", "-")}
    ref={ref}
    style={style}
  >
    <div
      onClick={(e) => {
        setSelectedCategory(
          category?.category_name?.replace(" ", "-")
        );
      }}
      className={`categorydrag ${cardClass} ${selectedCategory === category?.category_name?.replace(" ", "-") ? "categoryacrive" : ''}`}
    >
      <span className="catbtnspan">
        <ViewGridIcon {...props} className="dragicon" />
        <span>
          <span>
            {category?.category_name}
            {" "}<span>
              ({currentMenu?.category_and_items
                ?.find(i => i.category_uuid === category?.category_uuid)
                ?.menu_items?.filter(
                  item => +item?.menu_item_status > 0 &&
                    allItem?.find(i => item.item_uuid === i.item_uuid && i.category_uuid === category?.category_uuid)
                )?.length
              }/{currentMenu?.category_and_items
                ?.find(i => i.category_uuid === category?.category_uuid)
                ?.menu_items
                ?.filter(item => allItem?.find(i => item.item_uuid === i.item_uuid && i.category_uuid === category?.category_uuid))?.length
              })
            </span>
          </span>
        </span>
      </span>
      <div>
        <PencilAltIcon
          onClick={(e) => {
            setEditCategoryOpen(!editCategoryOpen);
            setId(category?.category_uuid);
          }}
          className="editicon"
          onMouseOver={() =>
            setHoverState(
              category?.category_name
            )
          }
          onMouseLeave={() =>
            setHoverState("")
          }
        />
        <input
          className='staricon'
          type='checkbox'
          onClick={e => e.stopPropagation()}
          checked={!currentMenu.category_and_items.filter(a => a.category_uuid === category.category_uuid).filter(a => a.menu_items.filter(a => +a.menu_item_status === 0).length).length}
          onChange={(e) => {
            setCurrentMenu({
              ...currentMenu,
              category_and_items:
                currentMenu?.category_and_items?.map(
                  (a) => {
                    if (
                      a?.category_uuid ===
                      category?.category_uuid
                    ) {
                      return {
                        ...a,
                        menu_items:
                          a?.menu_items?.map((c) => (
                            {
                              ...c,
                              menu_item_status:
                                e.target.checked ? "1" : "0"
                            }

                          )),
                      };
                    } else return a;
                  }
                ),
            })
          }
          }
        />
      </div>
      {category?.category_name === hoverState ? (
        <div
          style={{
            position: "absolute",
            width: "120px",
            bottom: "120%",
            left: "50%",
          }}>
          <HoverData text='Edit Category' />
        </div>
      ) : (
        ""
      )}
    </div>
  </div>)
});

const HoverData = ({ text }) => (
  <div
    style={{
      textDecoration: "none",
      position: "absolute",
      backgroundColor: "black",
      color: "white",
      padding: "3px 0",
      borderRadius: "20px",
      fontSize: "15px",
      width: "100%",
      textAlign: "center",
      zIndex: "9999999999999",
    }}>
    {text}
  </div>
);
